// Based on
export const POSSIBLE_AXES_STRING = {
  DEGREECELCIUS: '°C',
  KELVIN: 'K',
  BAR: 'bar',
  PA: 'Pa',
  SIEMENS: 'S',
  METER: 'm',
  VOLT: 'V',
  AMPERE: 'A',
  HOUR: 'h',
  MINUTE: 'min',
  SECOND: 's',
  METER_PER_SECOND: 'm/s',
  NEWTON: 'N',
  GRAM: 'g',
  PERCENT_HUMIDITY: '%rH',
  HERTZ: 'Hz',
  OHM: 'Ohm',
  PERCENT: '%',
  LITER_PER_MINUTE: 'l/min',
  LITER_PER_HOUR: 'l/h',
  LITER_PER_SECOND: 'l/s',
  PER_LITER: '1/l',
  RPS: '1/s',
  RPM: '1/min',
};
/**
 *
 * @param {string} string unit type
 * @returns the string if exist in dictionary else return tha argument again
 */
export const getAxisName = (string) => POSSIBLE_AXES_STRING[string] || string;
